export const UNIT_CONVERSION = {
  KWH_PER_MWH: 1000,
  KW_PER_MW: 1000,
  YUAN_PER_TEN_THOUSAND_YUAN: 10000,
} as const;

interface FormatNumberOptions {
  useTenThousandUnit?: boolean;
}

export const formatNumber = (value: unknown, { useTenThousandUnit = true }: FormatNumberOptions = {}) => {
  if (value == null || value === '') return '--';
  const numberValue = Number(value);
  if (!Number.isFinite(numberValue)) return '--';

  const shouldUseTenThousandUnit = useTenThousandUnit && Math.abs(numberValue) >= 10000;
  const displayValue = shouldUseTenThousandUnit
    ? numberValue / UNIT_CONVERSION.YUAN_PER_TEN_THOUSAND_YUAN
    : numberValue;
  return `${displayValue.toFixed(2)}${shouldUseTenThousandUnit ? '万' : ''}`;
};

export const formatValue = (value: unknown, unit = '', options?: FormatNumberOptions) => {
  const formattedValue = formatNumber(value, options);
  return formattedValue === '--' ? formattedValue : `${formattedValue}${unit}`;
};

export const yuanToTenThousandYuan = (value: unknown) => {
  if (value == null || value === '') return undefined;
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue / UNIT_CONVERSION.YUAN_PER_TEN_THOUSAND_YUAN : undefined;
};
